import { useMutation } from "@tanstack/react-query";
import { dislikeQuery } from "@/api/mutations";

type UseCardMutationsProps = {
  organizationId: string;
  productId: string;
  requestId: string;
};

export function useCardMutations({ organizationId, productId, requestId }: UseCardMutationsProps) {
  const baseParams = { organizationId, productId, requestId };

  const dislikeMutation = useMutation({
    mutationFn: ({
      queryId,
      isDisliked,
      dislikeComment,
    }: {
      queryId: string;
      isDisliked: boolean;
      dislikeComment?: string;
    }) => dislikeQuery({ ...baseParams, queryId, isDisliked, dislikeComment }),
  });

  return {
    dislike: dislikeMutation,
  };
}
